import { Pipe, PipeTransform } from '@angular/core';
import { StatistikProduktivitetMedarbejder } from '../../models/StatistikProduktivitetMedarbejder';

@Pipe({
    name: 'totalFromProperty',
    standalone: false
})
export class TotalFromPropertyPipe implements PipeTransform {
    transform(array: StatistikProduktivitetMedarbejder[], property: string): number {
        if (!array || array.length < 1) {
            return 0;
        }
        return array?.reduce((total, medarbejder) => {
            if (!medarbejder.excludeFromCalculation) {
                return medarbejder[property] + total;
            }
            return total;
        }, 0);
    }
}
